import React, { Component } from 'react';

import moment from 'moment';

import './SubscriptionDate.css';
import { inject, observer } from 'mobx-react';

@inject('translationsStore', 'commonStore')
@observer
export default class SubscriptionDate extends Component {
  showDate = date => {
    if (date) {
      return moment(date || new Date()).format(this.props.commonStore.longDateFormat.L);
    }
    return '-';
  };

  render() {
    const { translationsStore } = this.props;
    return (
      <div className="SubscriptionDate">
        <div>
          <div style={{ fontWeight: 'bold' }}>{translationsStore.translate('carView.client.subscriptionStart')}:</div>
          <strong>{this.showDate(this.props.subscriptionStart)}</strong>
        </div>

        <div>
          <div style={{ fontWeight: 'bold' }}>{translationsStore.translate('carView.client.subscriptionEnd')}:</div>
          <strong>{this.showDate(this.props.subscriptionEnd)}</strong>
        </div>
      </div>
    );
  }
}
